<template>
  <Slideout :id="slideoutId" title="International Shipping" @close-slideout="onSlideoutClose">
    <InternationalContext v-if="showForm" @on-submit="toggleSlideout" />
  </Slideout>
</template>

<script setup>
/* v8 ignore file -- @preserve */
import Slideout from '@nuxt-common/atomic-ui/app/components/slideout/Slideout';
import { defineAsyncComponent } from 'vue';
import useInternationalSlideout from '~/composables/features/useInternationalSlideout';

const slideoutId = 'int-context_navigation';
const InternationalContext = defineAsyncComponent(() => import('@nuxt-common/international-context/app/components/InternationalContext'));
const { init, showForm, toggleSlideout, onSlideoutClose } = useInternationalSlideout();

init(slideoutId);
</script>
